<!-- <div class="notification">
	<a [routerLink]="['/peking-duck-meal-kit']">Ordered a Meal Kit? Learn more &#8594;</a>
</div>
 -->
<div class="body-container">


	<section class="home section">
			<div class="home-container">
				<img class="home-image" src="/static/tpdg/home/tpdg-banner.webp" >	
			</div>
			<div class="home-container black-bg">
				<!-- <video class="home-video" #videoPlayer [autoplay]="true" playsinline="true" loop="true" [muted]="true" >
					<source src="/static/tpdg/home/home-video-landscape.mp4" type="video/mp4">
					<p>Your browser does not support the video tag.q</p>
				</video> -->

				<div class="carousel" id="img-carousel" (scroll)="onScroll($event)">
					<img class="slide" src="/static/tpdg/notes/home/gallery-1.webp"/>
					<img class="slide" src="/static/tpdg/notes/home/gallery-2.webp"/>
					<img class="slide" src="/static/tpdg/notes/home/gallery-3.webp"/>
				</div>

				<button type="button" [id]="'carousel-prev'"  class="carousel-button previous hide-button" aria-label="Previous" role="button" tabindex="0" (click)="previous($event, 'img-carousel')" >
			        <svg class="arrow" viewBox="-18 -17 50 50" >
					  <path 
					   d="M1.7 10.2l5.7 5.7c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.9-5 4.9-5c.4-.4.4-1 0-1.4L8.8.3c-.4-.4-1-.4-1.4 0L.3 7.4c-.4.4-.4 1 0 1.4l1.4 1.4z"/>
					</svg>
			</button>

			<button type="button" [id]="'carousel-next'" class="carousel-button next" aria-label="Next" role="button" tabindex="0" (click)="next($event, 'img-carousel')" >
		        <svg class="arrow right"viewBox="-18 -17 50 50">
				  <path 
				   d="M1.7 10.2l5.7 5.7c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.9-5 4.9-5c.4-.4.4-1 0-1.4L8.8.3c-.4-.4-1-.4-1.4 0L.3 7.4c-.4.4-.4 1 0 1.4l1.4 1.4z"/>
				</svg>
			</button>
			</div>

			
	</section>

	<section class="component-container section">
		<div class="mailing-list text">
			<div class="title-2 orange-text">Join Our Mailing List</div>
			<div class="confirmation-message" *ngIf="!showForm">
				Thank you for your submission. You're on the list!
			</div>
			<form class="mailing-list-input" *ngIf="showForm">
				<input placeholder="Your Name" [(ngModel)]="name" name="name"/>
				<input placeholder="Your Email" [(ngModel)]="email" name="email" type="email"/>
					<button *ngIf="captchaToken!='' 
					&& email!='' 
					&& name!='' " class="button" (click)="submitForm($event)">Submit</button>

			<re-captcha class="captcha"
				*ngIf="captchaToken =='' 
					|| email =='' 
					|| name =='' "
			    (resolved)="onCaptchaResolved($event)"
			    [siteKey]="siteKey">
			  </re-captcha>
			</form>

		</div>
	</section>


	<section class="component-container section ">
		
		<div class="container-content" style="display:flex;flex-direction: row;">
			<div class="record-first-text-container">
			<div class="badge  bumper-top">About</div>
			<div class="text  bumper-bottom"><span class="title-3 orange-text">The Process</span></div>
				<div *ngFor="let item of notesFocus.body; index as i" class="text" [class.expand]="i==0" (click)="toggle($event, item.image)">
					<div class="title-2" >
						<svg
					    class="plus-icon "
					    viewBox="0 0 100 100">
					    <line class="line vertical" x1="50" y1="20" x2="50" y2="80" />
					    <line class="line horizontal" x1="20" y1="50" x2="80" y2="50" />
					  </svg>
						{{item.title}}
					</div>
					<div class="accordion" >
						<p [innerHTML]="formatTextArray(item.text, item.image_position, item.image)"></p>
						<img class="accordion-image" src="{{item.image}}"/>
					</div>
				</div>
			</div>
		</div>
	</section>


	<section class="component-container  bumper-top section">
			<div class="badge bumper-left">In Action</div>
			<div class="text"><span class="title-3 black-text bumper-left">Take a Peek</span></div>

		<div class="container-content  black-bg">

			<div class="gallery-container">
				
				<img class="notes_img gallery-img" src="/static/tpdg/notes/home/gallery-5.webp"/>
				<img class="notes_img gallery-img" src="/static/tpdg/notes/home/gallery-10.webp"/>
				<img class="notes_img gallery-img" src="/static/tpdg/notes/home/gallery-7.webp"/>
				<img class="notes_img gallery-img" src="/static/tpdg/notes/home/gallery-8.webp"/>
				<img class="notes_img gallery-img" src="/static/tpdg/notes/home/gallery-4.webp"/>
								<img class="notes_img gallery-img" src="/static/tpdg/notes/home/gallery-9.webp"/>

			</div>	
			<div class="spacer"></div>

		</div>
	</section>
</div>